module.exports = __webpack_public_path__ + "static/img/LanceFranklin.129d746.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LanceFranklin.jpg
// module id = E127
// module chunks = 0